<template>
  <div ref="card"></div>
</template>

<script>
let stripe = Stripe(`${process.env.VUE_APP_STRIPE_PUBLIC_KEY}`),
    elements = stripe.elements(),
    card = undefined;

export default {
  mounted: function () {
    card = elements.create('card');
    card.mount(this.$refs.card);
  }
};
</script>